module.exports = __webpack_public_path__ + "static/media/diplomaBg.75c9f235.png";